//==============================
// Showcase
//==============================

var showcaseLTR = $('.showcase-row-ltr');
var showcaseRTL = $('.showcase-row-rtl');


showcaseLTR.imagesLoaded().progress( function() {
  setTimeout(function() {
    
    showcaseLTR.slick({
      infinite: true,
      centerMode: true,
      slidesToShow: 1,
      variableWidth: true,
      dots: false,
      arrows: false,
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,
      draggable: false,
      swipe: false,
      swipeToSlide: false
    });

    showcaseLTR.addClass('show');

  }, 500);
});

showcaseRTL.imagesLoaded().progress( function() {
  setTimeout(function() {
    
    showcaseRTL.slick({
      rtl: true,
      infinite: true,
      centerMode: true,
      slidesToShow: 1,
      variableWidth: true,
      dots: false,
      arrows: false,
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,
      draggable: false,
      swipe: false,
      swipeToSlide: false
    });

    showcaseRTL.addClass('show');
        
  }, 500);
});


